import type { BreadcrumbItem } from "@/domains/navigation"
import { ManualClV1ManagePagesComplexBreadcrumbApplication } from "@/domains/navigation/components/complex-breadcrumb-applications/manual-cl-v1-manage-pages-complex-breadcrumb-application"
import { ManualClV1PositionComplexBreadcrumbApplication } from "@/domains/navigation/components/complex-breadcrumb-applications/manual-cl-v1-position-complex-breadcrumb-application"
import { CreateManualClLiquiditySubItem } from "@/domains/navigation/subitems/create-manualcl-liquidity-subitem"
import {
  ManualClAllPoolsSubItem,
  ManualClMyPositionsSubItem,
} from "@/domains/navigation/subitems/manualcl-liquidity-subitem"

export const MANUAL_CL_V1_BREADCRUMBS: BreadcrumbItem[] = [new ManualClAllPoolsSubItem()]

export const CREATE_MANUAL_CL_V1_BREADCRUMBS: BreadcrumbItem[] = [
  new ManualClAllPoolsSubItem(),
  new CreateManualClLiquiditySubItem(),
]

export const MANAGE_MANUAL_CL_V1_BREADCRUMBS: BreadcrumbItem[] = [
  new ManualClAllPoolsSubItem(),
  new ManualClMyPositionsSubItem(),
  ManualClV1PositionComplexBreadcrumbApplication,
  ManualClV1ManagePagesComplexBreadcrumbApplication,
]
